<template>
  <div class="wrapper">
    <i class="rotate iconfont icon-bofang1" @click="Autorotate" v-if="isShowRotate"></i>
    <i class="rotate iconfont icon-iconfont32" @click="Autorotate" v-else></i>
    <i
      class="deviceOrientation iconfont icon-zhongliganyingcopy"
      @click="DeviceOrientation"
      v-if="!isDeviceOrientation"
    ></i>
    <i
      class="deviceOrientation iconfont icon-zhongliganying-guan"
      @click="DeviceOrientation"
      v-else
    ></i>
    <i
      class="stereoView iconfont icon-vr"
      @click="StereoView"
      v-if="!isStereoView"
    ></i>
    <i
      class="stereoView iconfont icon-vr1"
      @click="StereoView"
      v-else
    ></i>
    <ul class="btn-wrapper">
      <li v-for="item in btnList" class="item">
        <van-button
          type="default"
          class="btn"
          :class="{active: isActive===item.id}"
          @click="switchMarkers(item.id)"
        >{{item.name}}</van-button>
      </li>
    </ul>

    <div id="viewer"></div>

  </div>
</template>

<script>
const THREE = window.THREE = require('three')
require('three/examples/js/controls/DeviceOrientationControls')
require('three/examples/js/effects/StereoEffect')
import PhotoSphereViewer from "photo-sphere-viewer";
import { Button } from "vant";
export default {
  name: "panorama",
  components: {
    [Button.name]: Button
  },
  data() {
    return {
      viewer: null,
      isShowRotate: false,
      isDeviceOrientation: false,
      isStereoView:false,
      btnList: [
        { id: 0, name: "路网交通" },
        { id: 1, name: "医疗教育" },
        { id: 2, name: "商业休闲" },
        { id: 3, name: "自然资源" }
      ],
      isActive: -1
    };
  },

  created() {
    this.$nextTick(() => {
      this._photoShereViewer();
      PhotoSphereViewer.SYSTEM.deviceOrientationSupported = new Promise(resolve => resolve(true))
    });
  },

  methods: {
    _photoShereViewer() {
      this.viewer = new PhotoSphereViewer({
        container: "viewer",
        panorama: "https://img2.tutubox.cn/panorama-.jpg",
        navbar: false,
        // gyroscope: true,
        size: {
          width: "100%",
          height: "100%"
        },
        min_fov: 70,
        max_fov: 115,
        markers: [
          {
            id: "image",
            longitude: 1.25,
            latitude: -0.7,
            image: "pin1.png",
            width: 32,
            height: 32,
            anchor: "bottom center"
          },
          {
            id: "square",
            longitude: 0.28,
            latitude: -0.5,
            html: "中心广场",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "hospital",
            longitude: 1.6,
            latitude: -0.95,
            html: "人民医院",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "shop",
            longitude: -0.7,
            latitude: -0.95,
            html: "大润发商场",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "spring",
            longitude: -2.1,
            latitude: -0.25,
            html: "温泉旅游度假区",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "speed",
            longitude: -1.65,
            latitude: -0.25,
            html: "二广高速",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "way",
            longitude: -3.45,
            latitude: -0.3,
            html: "金山大道",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "parkland",
            longitude: -4.55,
            latitude: -0.1,
            html: "景山自然风景区",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            }
          },
          {
            id: "school",
            longitude: -2.8,
            latitude: -0.5,
            html: "实验中学",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },
            
          },
            {
            id: "yanjianglu",
            longitude: 0.9,
            latitude: -0.55,
            html: "沿江西路",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },
            
          },
           {
            id: "chuangxinlu",
            longitude: -0.15,
            latitude: -0.2,
            html: "创新大道",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },
            
          },
          {
            id: "qiguanglu",
            longitude: -0.85,
            latitude: -0.2,
            html: "齐广高速",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },  
          },
          {
            id: "forest",
            longitude: 0.2,
            latitude: -0.3,
            html: "石门森林公园",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },  
          },
            {
            id: "middleSchool",
            longitude: 1.1,
            latitude: -0.45,
            html: "实验二中",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },  
          },
            {
            id: "wanda",
            longitude: -2.7,
            latitude: -0.25,
            html: "万达广场",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },  
          },
           {
            id: "jinianPark",
            longitude: 0.75,
            latitude: -0.35,
            html: "纪念公园",
            anchor: "bottom right",
            // scale: [0.5, 1.5],
            style: {
              minWidth: "60px",
              height: "25px",
              padding: "0 5px",
              "background-color": "rgba(0,0,0,0.5)",
              "border-radius": "25px",
              "line-height": "25px",
              color: "#fff",
              fontSize: "14px",
              fontFamily: "Helvetica, sans-serif",
              textAlign: "center"
            },  
          },
        ]
      });
      
      let that = this;
      this.viewer.on("select-marker", function(marker) {
        if (marker.id === "image") {
          that.$router.push("/project");
        }
      });
    },

    Autorotate() {
      this.isShowRotate = !this.isShowRotate;
      if( this.isShowRotate ) {
        this.viewer.startAutorotate();
      } else {
        this.viewer.stopAutorotate();
      }
    },

    DeviceOrientation() {
      this.isDeviceOrientation = !this.isDeviceOrientation;
      if(this.isDeviceOrientation) {
        this.viewer.startGyroscopeControl();
      } else {
        this.viewer.stopGyroscopeControl();
      }
      
    },

    StereoView() {
      this.isStereoView = !this.isStereoView
      if(this.isStereoView) {
        this.viewer.startStereoView()
      } else {
        this.viewer.stopStereoView()
      }
    },

    switchMarkers(id) {
      this.isActive = id;
      if (id === 0) {
        this.viewer.hideMarker("square");
        this.viewer.hideMarker("hospital");
        this.viewer.hideMarker("shop");
        this.viewer.hideMarker("spring");
        this.viewer.hideMarker("speed");
        this.viewer.hideMarker("way");
        this.viewer.hideMarker("parkland");
        this.viewer.hideMarker("school");
        this.viewer.hideMarker("yanjianglu");
        this.viewer.hideMarker("chuangxinlu");
        this.viewer.hideMarker("qiguanglu");
        this.viewer.hideMarker("forest");
        this.viewer.hideMarker("middleSchool");
        this.viewer.hideMarker("wanda");
        this.viewer.hideMarker("jinianPark");



        this.viewer.showMarker("qiguanglu");
        this.viewer.showMarker("chuangxinlu");
        this.viewer.showMarker("yanjianglu");
        this.viewer.showMarker("speed");
        this.viewer.showMarker("way");
      } else if (id === 1) {
        this.viewer.hideMarker("square");
        this.viewer.hideMarker("hospital");
        this.viewer.hideMarker("shop");
        this.viewer.hideMarker("spring");
        this.viewer.hideMarker("speed");
        this.viewer.hideMarker("way");
        this.viewer.hideMarker("parkland");
        this.viewer.hideMarker("school");
        this.viewer.hideMarker("yanjianglu");
        this.viewer.hideMarker("chuangxinlu");
        this.viewer.hideMarker("qiguanglu");
        this.viewer.hideMarker("forest");
        this.viewer.hideMarker("middleSchool");
        this.viewer.hideMarker("wanda");
        this.viewer.hideMarker("jinianPark");

        




        this.viewer.showMarker("middleSchool");
        this.viewer.showMarker("hospital");
        this.viewer.showMarker("school");
      } else if (id === 2) {
        this.viewer.hideMarker("square");
        this.viewer.hideMarker("hospital");
        this.viewer.hideMarker("shop");
        this.viewer.hideMarker("spring");
        this.viewer.hideMarker("speed");
        this.viewer.hideMarker("way");
        this.viewer.hideMarker("parkland");
        this.viewer.hideMarker("school");
        this.viewer.hideMarker("yanjianglu");
        this.viewer.hideMarker("chuangxinlu");
        this.viewer.hideMarker("qiguanglu");
        this.viewer.hideMarker("forest");
        this.viewer.hideMarker("middleSchool");
        this.viewer.hideMarker("wanda");
        this.viewer.hideMarker("jinianPark");



        this.viewer.showMarker("wanda");
        this.viewer.showMarker("forest");
        this.viewer.showMarker("square");
        this.viewer.showMarker("shop");
      } else if (id === 3) {
        this.viewer.hideMarker("square");
        this.viewer.hideMarker("hospital");
        this.viewer.hideMarker("shop");
        this.viewer.hideMarker("spring");
        this.viewer.hideMarker("speed");
        this.viewer.hideMarker("way");
        this.viewer.hideMarker("parkland");
        this.viewer.hideMarker("school");
        this.viewer.hideMarker("yanjianglu");
        this.viewer.hideMarker("chuangxinlu");
        this.viewer.hideMarker("qiguanglu");
        this.viewer.hideMarker("forest");
        this.viewer.hideMarker("middleSchool");
        this.viewer.hideMarker("wanda");
        this.viewer.hideMarker("jinianPark");





        this.viewer.showMarker("jinianPark");
        this.viewer.showMarker("spring");
        this.viewer.showMarker("parkland");
      }
    }
  }
};
</script>

<style lang="less" scope>
.wrapper {
  position: relative;
  height: 100%;
  .rotate {
    position: absolute;
    right: 10px;
    top: 60px;
    z-index: 999;
    font-size: 20px;
  }
  .deviceOrientation {
    position: absolute;
    right: 10px;
    top: 110px;
    z-index: 999;
    font-size: 20px;
  }
  .stereoView{
    position: absolute;
    right: 10px;
    top: 160px;
    z-index: 999;
    font-size: 20px;
  }
  .btn-wrapper {
    position: absolute;
    left: 10px;
    top: 20px;
    z-index: 999;
    .item {
      margin-bottom: 5px;
      .btn {
        height: 30px;
        line-height: 30px;
        border-radius: 30px;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        border: 0;
      }
      .active {
        background-color: #1989fa;
      }
    }
  }
  #viewer {
    width: 100%;
    height: 100%;
  }
}
</style>
